import React from "react";
import { Check, Clock } from "lucide-react";
import { SERVICES } from "../../lib/services";
import { SVC_KEYS } from "./utils";

export default function StepService({ tier, setTier, serviceType, setServiceType, extras, setExtras, services, additionalServices }) {
  const toggleExtra = (id) => setExtras(extras.includes(id) ? extras.filter(x => x !== id) : [...extras, id]);
  const visibleExtras = additionalServices.filter(a => a.id !== "mobile_service");
  // Merge live services with static marketing copy (features/taglines/images live in services.js)
  const liveTier = services?.[tier] || SERVICES[tier];
  return (
    <div className="space-y-6">
      {/* Mini "jak to funguje" strip */}
      <div className="rounded-xl bg-apex-card/60 border border-apex-line px-4 py-3 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] md:text-xs text-apex-cream/60" data-testid="booking-howto-strip">
        <span className="inline-flex items-center gap-1.5"><span className="w-4 h-4 rounded-full bg-apex-gold text-apex-bg font-bold flex items-center justify-center text-[9px]">1</span> Vyberte službu a termín</span>
        <span className="text-apex-gold/50">→</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-4 h-4 rounded-full bg-apex-gold/20 text-apex-gold font-bold flex items-center justify-center text-[9px]">2</span> Do 1 hodiny potvrdíme</span>
        <span className="text-apex-gold/50">→</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-4 h-4 rounded-full bg-apex-gold/20 text-apex-gold font-bold flex items-center justify-center text-[9px]">3</span> Zaplatíte online či na místě</span>
      </div>
      <div>
        <div className="text-sm text-apex-cream/70 mb-2">Řada služeb</div>
        <div className="inline-flex p-1 rounded-xl bg-apex-card border border-apex-cream/25">
          {[{ id: "classic", label: "Classic" }, { id: "detailing", label: "Premium" }].map(t => (
            <button
              key={t.id}
              onClick={() => setTier(t.id)}
              className={`px-5 py-2 rounded-lg text-sm font-semibold transition ${tier === t.id ? "" : "text-apex-cream hover:text-apex-cream/70"}`}
              style={tier === t.id ? { background: "var(--krem-tmava)", color: "var(--text-tmavy)" } : undefined}
              data-testid={`booking-tier-${t.id}`}
            >{t.label}</button>
          ))}
        </div>
      </div>
      <div>
        <div className="text-sm text-apex-cream/70 mb-2">Služba</div>
        <div className="grid md:grid-cols-3 gap-3">
          {SVC_KEYS.map((k) => {
            const s = liveTier[k];
            const sel = serviceType === k;
            return (
              <button key={k} onClick={() => setServiceType(k)} className={`relative text-left rounded-2xl p-5 border transition-all ${
                sel ? "bg-apex-card border-[var(--stribro-text)]" : "bg-apex-card border-[#bababa]/30 hover:border-apex-cream/40"
              }`} data-testid={`booking-svc-${k}`}>
                {k === "complete" && (
                  <span
                    className="absolute -top-2.5 right-4 text-[10px] font-bold uppercase tracking-wider px-2.5 py-0.5 rounded-full text-white"
                    style={{ background: "#3a3a3a" }}
                  >Nejoblíbenější</span>
                )}
                <div className="text-apex-cream font-semibold">{s.name}</div>
                <div className="mt-2 text-2xl font-display text-apex-cream">{s.price.toLocaleString("cs-CZ")} Kč</div>
                <div className="mt-1 text-xs text-apex-cream/60 flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {s.duration} min</div>
              </button>
            );
          })}
        </div>
      </div>
      <div>
        <div className="text-sm text-apex-cream/70 mb-2">Příplatkové služby (volitelné)</div>
        <div className="grid md:grid-cols-2 gap-2">
          {visibleExtras.map(a => {
            const sel = extras.includes(a.id);
            return (
              <button key={a.id} onClick={() => toggleExtra(a.id)} className={`flex items-center justify-between gap-3 rounded-xl border p-3 text-sm transition ${
                sel ? "bg-apex-gold/10 border-apex-gold text-apex-cream" : "bg-apex-card border-apex-line text-apex-cream/85 hover:border-apex-gold/40"
              }`} data-testid={`booking-extra-${a.id}`}>
                <span className="flex items-center gap-2">
                  <span className={`w-4 h-4 rounded border flex items-center justify-center ${sel ? "bg-apex-gold border-apex-gold" : "border-apex-line"}`}>
                    {sel && <Check className="w-3 h-3 text-apex-bg" />}
                  </span>
                  {a.name}
                </span>
                <span className="text-apex-gold font-semibold whitespace-nowrap">+{a.price} Kč</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
